<template>
    <div class="token-settings p-4">
      <h4 class="mb-4 text-center">
        การจัดการ Token
        <img
          src="/img/languages/silom-token.png"
          alt="Token"
          style="width: 18px; height: 18px"
          class="ml-1"
        />
      </h4>

      <hr/>
      <CRow class="mb-4">
        <CCol md="3" v-for="(stat, key) in tokenStatsDisplay" :key="key">
            <CCard class="stat-card shadow-sm p-3">
            <CCardBody class="d-flex flex-column align-items-start justify-content-center">
                <div class="d-flex align-items-center mb-2">
                <CIcon :name="stat.icon" :class="['icon-circle', stat.bg]" class="mr-2" />
                <h6 :class="stat.color" class="mb-0">{{ stat.title }}</h6>
                </div>
                <div class="d-flex align-items-center">
                <h3 class="font-weight-bold mb-0">{{ stat.value }}</h3>
                <img src="/img/languages/silom-token.png" alt="Token" style="width: 20px; height: 20px;" class="ml-2" />
                </div>
            </CCardBody>
            </CCard>
        </CCol>
        </CRow>

  
      <CRow class="mb-4">
        <CCol md="6">
          <CButton color="primary" block @click="showTopupModal = true">
            เติม Token
            <img src="/img/languages/silom-token.png" alt="Token" style="width: 18px; height: 18px" class="ml-1" />
          </CButton>
        </CCol>
        <CCol md="6">
          <CButton color="info" block @click="showTokenHistoryModal = true">
            ประวัติการใช้ Token
          </CButton>
        </CCol>
      </CRow>
      <CRow class="mb-3">
        <CCol>
            <CCard class="border-left-success shadow-sm">
            <CCardBody class="d-flex justify-content-between align-items-center">
                <div>
                <h6 class="text-success mb-1">แพ็กเกจที่ใช้งานอยู่</h6>
                <p class="mb-0 font-weight-bold">
                    {{ activePackage.name }} - {{ activePackage.amount }} Token
                    <img src="/img/languages/silom-token.png" alt="Token" style="width: 16px; height: 16px;" class="ml-1" />
                </p>
                <p class="mb-0 text-muted">ราคา: ฿{{ activePackage.price }}</p>
                <p class="mb-0 text-muted">ซื้อเมื่อ: {{ formatDate(activePackage.purchasedAt) }}</p>
                
                </div>
                <div>
                <CBadge color="success">กำลังใช้งาน</CBadge>
                <div class="mt-2">
                    <CProgress :value="packageUsagePercent" color="success" />
                    <small class="text-muted">{{ tokensUsed }} / {{ activePackage.amount }} Token</small>
                </div>
                </div>
            </CCardBody>
            </CCard>
        </CCol>
        </CRow>
      <modal :show.sync="showTopupModal" title="เติม Token" size="lg">
        <div>
          <h5 class="mb-3">แพ็กเกจ Token</h5>
          <CRow>
            <CCol
              v-for="pkg in tokenPackages"
              :key="pkg.id"
              md="4"
              class="mb-3"
            >
              <CCard :class="['text-center', 'h-100', { 'border border-success': pkg.active }]">
                <CCardBody>
                  <h6 class="text-primary">{{ pkg.name }}</h6>
                  <p>
                    {{ pkg.amount }} Token
                    <img
                      src="/img/languages/silom-token.png"
                      alt="Token"
                      style="width: 16px; height: 16px"
                      class="ml-1"
                    />
                  </p>
                  <h5 class="text-success">฿{{ pkg.price }}</h5>
                  <CButton
                    :color="pkg.active ? 'secondary' : 'success'"
                    :disabled="pkg.active"
                    @click="selectPackage(pkg)"
                  >
                    {{ pkg.active ? 'แพ็กเกจปัจจุบัน' : 'ซื้อแพ็กเกจ' }}
                  </CButton>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </div>
      </modal>
  
      <modal :show.sync="showTokenHistoryModal" title="ประวัติการใช้ Token" size="lg">
        <div>เนื้อหาสำหรับประวัติการใช้ Token</div>
      </modal>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        tokenStats: {
          remaining: 1000,
          monthlyUsed: 200,
          todayUsed: 10,
          avgPerDay: 7
        },
        tokenPackages: [
            { id: 1, name: 'แพ็กเล็ก', amount: 100, price: 49, active: false },
            { id: 2, name: 'แพ็กกลาง', amount: 300, price: 129, active: true, purchasedAt: '2025-04-22' },
            { id: 3, name: 'แพ็กใหญ่', amount: 1000, price: 399, active: false },
        ],
        showTopupModal: false,
        showTokenHistoryModal: false,
      };
    },
    computed: {
        tokenStatsDisplay() {
            return {
            remaining: {
                title: 'Token คงเหลือ',
                value: this.tokenStats.remaining,
                color: 'text-success',
                bg: 'bg-green',
                icon: 'cil-wallet'
            },
            monthlyUsed: {
                title: 'Token ที่ใช้เดือนนี้',
                value: this.tokenStats.monthlyUsed,
                color: 'text-warning',
                bg: 'bg-yellow',
                icon: 'cil-calendar'
            },
            todayUsed: {
                title: 'Token ที่ใช้วันนี้',
                value: this.tokenStats.todayUsed,
                color: 'text-danger',
                bg: 'bg-red',
                icon: 'cil-clock'
            },
            avgPerDay: {
                title: 'เฉลี่ยต่อวัน',
                value: this.tokenStats.avgPerDay,
                color: 'text-muted',
                bg: 'bg-gray',
                icon: 'cil-graph'
            }
            };
        },
      activePackage() {
            return this.tokenPackages.find(pkg => pkg.active) || { name: '-', amount: 0, price: 0 };
        },
        tokensUsed() {
    return this.tokenStats.monthlyUsed; // หรือแก้ logic ให้ดึงจาก backend ได้
  },
  packageUsagePercent() {
    const total = this.activePackage.amount || 1;
    return Math.min((this.tokensUsed / total) * 100, 100);
  }
    },
    methods: {
      selectPackage(pkg) {
        if (!pkg.active) {
          this.$router.push({ path: '/token/topup', query: { packageId: pkg.id } });
        }
      },
      formatDate(dateStr) {
        if (!dateStr) return '-';
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        return new Date(dateStr).toLocaleDateString('th-TH', options);
     }
    }
  };
  </script>
  
  <style scoped>
  .token-settings h4 {
    font-weight: 600;
  }
  .stat-card {
  border-radius: 5px;
  transition: box-shadow 0.3s ease-in-out;
}
.stat-card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}
.icon-circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}
.bg-green {
  background-color: #28a745;
}
.bg-yellow {
  background-color: #ffc107;
}
.bg-red {
  background-color: #dc3545;
}
.bg-gray {
  background-color: #6c757d;
}
  
  </style>